/**
 * Mauritanian ouguiya.
 */
export var MRU = {
  code: 'MRU',
  base: 5,
  exponent: 1
};